import * as React from 'react';
export var EntityContext = React.createContext(null);
export var EntityProvider = function (_a) {
  var value = _a.value,
    children = _a.children;
  return React.createElement(EntityContext.Provider, {
    value: value
  }, children);
};